import axios from 'config/axiosConfig'
import { go } from "keys/apis"
import { isArray } from "lodash";

export const editNewsletterFetch = (values) => {
    let formData = new FormData();
    for (const key in values) {
        if (isArray(values[key]))//for contentImages
            values[key].forEach((image) => {
                formData.append(key, image); // 'images' הוא השם של השדה במודל
            });

        else formData.append(key, values[key]);
    }
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${go}news_letters/edit_newsletter/`,
        formData,
        // {
        //     // headers: {
        //     //    'Content-Type': 'application/json'
        //     // }
        // }
    )
}

export const getNewsletterFetch = () => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}news_letters/`)
}

export const removeNewsletterFetch = (id) => {
    return axios.delete(`${process.env.REACT_APP_SERVER_PORT}${go}news_letters/${id}/`)
}

export const getNewsletterByIdFetch = (id) => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}news_letters/${id}/`)
}


export const getAreasFetch = () => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}system_areas/`)
}

export const uploadImageFileFetch = (id, file) => {
    let formData = new FormData();
    formData.append("image", file);
    formData.append("id", id);

    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${go}news_letters/upload_file/`,
        formData,
        // {
        //     headers: {
        //         'Content-Type': 'multipart/form-data'
        //     }
        // }
    )
}

//not in use
export const removeFileFetch = (file_name) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${go}news_letters/remove_file/`, {
        file_name
    })
}
